import { render, staticRenderFns } from "./tinymce.vue?vue&type=template&id=f432f3a6&scoped=true"
import script from "./tinymce.vue?vue&type=script&lang=js"
export * from "./tinymce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f432f3a6",
  null
  
)

export default component.exports